
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/mirron",
      function () {
        return require("private-next-pages/cases/mirron/index.tsx");
      }
    ]);
  